import axios from 'axios';

const state = {
    settings: {
        is_active: false,
        notify_intervals: []
    },
    updated: 0
};

const getters = {
    getSettings: state => state.settings
};

const actions = {
    async getSettings({ commit }) {
        const response = await axios.get('/v1/hire-app/hiring-plan-notifications/settings');
        commit('setSettings', { settings: response.data });
        return response;
    },

    async updateSettings({ commit }, settings) {
        const response = await axios.put('/v1/hire-app/hiring-plan-notifications/settings', settings);
        commit('setSettings', { settings: response.data });
        return response;
    }
};

const mutations = {
    setSettings(state, { settings }) {
        state.settings = settings;
        state.updated = new Date().getTime();
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}; 